export const FAUCET_CONTRACT_ADDRESS =
  "0x6DF2EdA50D69A20544897D1A1A69790574e9d65A";
